import { render, staticRenderFns } from "./chat-setting.vue?vue&type=template&id=18d80ac5"
import script from "./chat-setting.vue?vue&type=script&lang=js"
export * from "./chat-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports